import { render } from "./ContactList.vue?vue&type=template&id=6b3c2202&scoped=true"
import script from "./ContactList.vue?vue&type=script&lang=js"
export * from "./ContactList.vue?vue&type=script&lang=js"

import "./ContactList.vue?vue&type=style&index=0&id=6b3c2202&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b3c2202"]])

export default __exports__